import React, { useState } from "react";
import { Input, Label } from "../input/Input";
import { Button } from "../button/Button";

export function RecuperarSenhaForm({ onSubmit }) {

  const [email, setEmail] = useState("");

  function handleSubmit(e) {
    e.preventDefault();

    onSubmit?.({
      email
    });
  }


  return (
    <div className="
      w-full 
      max-w-[400px] 
      bg-white 
      border 
      border-border 
      p-8 
      rounded-card 
      shadow-md 
      font-body 
      space-y-6
    ">

      <div className="text-center">

        <div className="
          w-12 h-12 
          rounded-xl 
          bg-primary 
          flex 
          items-center 
          justify-center 
          text-white 
          font-bold 
          text-2xl 
          mx-auto 
          mb-3
        ">
          S
        </div>

        <h2 className="
          font-display 
          text-h3 
          font-bold 
          text-text-primary
        ">
          Recuperar senha
        </h2>


        <p className="
          text-caption 
          text-text-secondary 
          mt-1
        ">
          Informe seu email para receber o link de recuperação.
        </p>

      </div>


      <form 
        onSubmit={handleSubmit}
        className="space-y-4"
      >

        <div>

          <Label htmlFor="email" required>
            Email
          </Label>


          <Input
            id="email"
            type="email"
            placeholder="nome@empresa.com"
            required
            value={email}
            onChange={(e)=>setEmail(e.target.value)}
          />

        </div>


        <Button 
          type="submit"
          className="w-full"
        >
          Enviar link de recuperação
        </Button>


      </form>


    </div>
  );
}